export default __webpack_public_path__ + "static/media/background.b886d43c.jpg";